import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Practitioner } from "@comunicare/comunicare-interfaces";
import { PractitionerService } from "src/app/providers/practitioner.service";

@Component({
  selector: "app-import-prescription-template-modal",
  templateUrl: "./import-prescription-template-modal.component.html",
  styleUrls: ["./import-prescription-template-modal.component.scss"],
})
export class ImportPrescriptionTemplateModalComponent implements OnInit {
  public form: UntypedFormGroup;
  constructor(
    public dialogRef: MatDialogRef<ImportPrescriptionTemplateModalComponent>,
    private fb: UntypedFormBuilder,
    public practitionerService: PractitionerService,
    @Inject(MAT_DIALOG_DATA)
    public data: { doctorSelected: Practitioner; availableDoctors: Practitioner[] }
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      practitioner: new FormControl<Practitioner>(this.data.doctorSelected, Validators.required),
      availableToService: new FormControl<boolean>(true),
    });
  }

  public save(): void {
    if (this.form.valid) {
      const values = this.form.getRawValue();
      this.dialogRef.close({
        practitioner: values.practitioner,
        availableToService: values.availableToService,
      });
    }
  }
}
